module.exports = __webpack_public_path__ + "static/media/luis.76017885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/luis.png
// module id = 343
// module chunks = 0